export default "__VITE_ASSET__9i3Oe8VL__"